export default "__VITE_ASSET__4e39e4b7__"